const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001/api';

const getAuthHeaders = () => {
  const token = localStorage.getItem('token');
  return {
    'Content-Type': 'application/json',
    ...(token && { 'Authorization': `Bearer ${token}` })
  };
};

const getAuthHeadersMultipart = () => {
  const token = localStorage.getItem('token');
  return {
    ...(token && { 'Authorization': `Bearer ${token}` })
  };
};

export const checkSupportAccess = async () => {
  const response = await fetch(`${API_URL}/support/access`, {
    headers: getAuthHeaders()
  });
  if (!response.ok) throw new Error((await response.json()).error || 'Failed to check access');
  return response.json();
};

export const createTicket = async ({ subject, category, priority, message, screenshot }) => {
  const formData = new FormData();
  formData.append('subject', subject);
  formData.append('category', category);
  formData.append('priority', priority);
  formData.append('message', message);
  if (screenshot) {
    formData.append('screenshot', screenshot);
  }

  const response = await fetch(`${API_URL}/support/tickets`, {
    method: 'POST',
    headers: getAuthHeadersMultipart(),
    body: formData
  });
  if (!response.ok) {
    const data = await response.json();
    throw new Error(data.error || 'Failed to create ticket');
  }
  return response.json();
};

export const getTickets = async ({ status, page = 1, limit = 20 } = {}) => {
  const params = new URLSearchParams({ page, limit });
  if (status && status !== 'all') params.set('status', status);

  const response = await fetch(`${API_URL}/support/tickets?${params}`, {
    headers: getAuthHeaders()
  });
  if (!response.ok) throw new Error((await response.json()).error || 'Failed to fetch tickets');
  return response.json();
};

export const getTicket = async (ticketId) => {
  const response = await fetch(`${API_URL}/support/tickets/${ticketId}`, {
    headers: getAuthHeaders()
  });
  if (!response.ok) throw new Error((await response.json()).error || 'Failed to fetch ticket');
  return response.json();
};

export const replyToTicket = async (ticketId, { message, screenshot }) => {
  const formData = new FormData();
  formData.append('message', message);
  if (screenshot) {
    formData.append('screenshot', screenshot);
  }

  const response = await fetch(`${API_URL}/support/tickets/${ticketId}/messages`, {
    method: 'POST',
    headers: getAuthHeadersMultipart(),
    body: formData
  });
  if (!response.ok) throw new Error((await response.json()).error || 'Failed to send reply');
  return response.json();
};

export const closeTicket = async (ticketId) => {
  const response = await fetch(`${API_URL}/support/tickets/${ticketId}/close`, {
    method: 'PATCH',
    headers: getAuthHeaders()
  });
  if (!response.ok) throw new Error((await response.json()).error || 'Failed to close ticket');
  return response.json();
};
